import { useEffect, useState } from "react";
import { fetchRecommendedGamesHome } from "../../api/GameApi";
import { Link } from "react-router-dom";

function GameRecommended() {
  const [appsRecommended, setAppRecommended] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecommendedGamesHome()
      .then((data) => {
        setAppRecommended(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const parseRating = (r) => {
      if (r === null || r === undefined || r === "") return 0;
      const n = typeof r === "number" ? r : Number(String(r).replace(",", "."));
      if (!Number.isFinite(n)) return 0;
      return Math.max(0, Math.min(5, n));
  };

  const renderStars = (rawRating) => {
      const rating = parseRating(rawRating);
      const totalStars = 5;
      const fullStars = Math.floor(rating);
      const halfStar = rating - fullStars >= 0.5 && fullStars < totalStars;
      const stars = [];

      for (let i = 0; i < totalStars; i++) {
      if (i < fullStars) stars.push(<span className="stars" key={i}>★</span>);
      else if (i === fullStars && halfStar) stars.push(<span className="stars" key={i}>⯪</span>);
      else stars.push(<span className="stars" key={i}>☆</span>);
      }

      return <span>{stars}</span>;
  };


  return (
    <section className="section">
      <div className="section-header">
        <h2 className="section-title">Recommended for you</h2>
        <Link to="/games/recommended" className="see-more">
          See more
        </Link>
      </div>
      <div className="horizontal-scroll">
        {appsRecommended.length > 0 ? (
              appsRecommended.slice(0, 24).map((app) => {
              const ratingNum = parseRating(app.rating);
              return (
                  <Link
                  to={`/app/details/${app.slug}`}
                  className="game-card horizontal-card"
                  key={app.id}
                  style={{ textDecoration: "none" }}
                  >
                  <div
                      className="game-image"
                      style={{
                      background: "linear-gradient(45deg, #fa709a, #fee140)",
                      backgroundImage: `url(${
                          app.feature_graphic_url
                          ? app.feature_graphic_url
                          : app.icon_url
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      }}
                  >
                      <div
                      className="game-icon"
                      style={{
                          backgroundImage: `url(${app.icon_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                      }}
                      ></div>
                  </div>

                  <div className="game-info">
                      <div className="game-title">{app.name}</div>
                      <div className="game-developer">{app.developer}</div>
                      <div className="game-rating">
                      {renderStars(ratingNum)}
                      <span className="rating-text">{ratingNum.toFixed(1)}</span>
                      </div>
                  </div>
                  </Link>
              );
              })
          ) : (
              <p>No apps available.</p>
          )}

      </div>
    </section>
  );
}

export default GameRecommended;
